export const heroOne = {
	reverse: true,
	inverse: true,
	topLine: {
		text: '2022',
	},
	headline: "Nova jornada!",
	description: 'O RPG é suuper recente, isso significa que todos vão evoluir juntos!',
	buttonLabel: 'Ver mais',
	imgStart: 'start',
	img: './assets/svg/Deal.svg',
	start: 'true',
};

export const heroTwo = {
	reverse: false,
	inverse: false,
	topLine: {
		text: 'Desenvolvido com carinho s2',
	},
	headline: 'Regras de boa convivência',
	description: 'Todos os chats do grupo são moderados para garantir que ninguém fique de fora!',
	buttonLabel: 'Ver mais',

	linkTo: '/more',
	imgStart: 'start',
	img: './assets/svg/Connection.svg',
	start: 'true',
};

export const heroThree = {
	reverse: true,
	inverse: true,
	topLine: {
		text: 'Aventura!',
	},
	headline: 'Sagas originais',
	description:
		'Novas sagas e missões são, frequentemente, criadas e aplicadas ao RPG! Isso significa que ainda teremos muuitas aventuras à caminho :D',
	buttonLabel: 'Ver mais',

	linkTo: '/download',
	imgStart: '',
	img: './assets/svg/ChartUp.svg',
	start: 'true',
};